<template>
    <div v-if="list.length > 0">
        <!-- 多問卷 -->
        <swiper :options="swiperOptions" v-if="list.length > 1">
            <swiper-slide class="pic" v-for="(item, index) in list" :key="index"
                 :style="{backgroundImage: 'url(' + item.imagePath + ')' }" @click.native="handleClick(item.id, item.url)">
            </swiper-slide>
        </swiper>
        <!-- 單一問卷 -->
        <div v-else >
                <div class="pic" v-for="(item, index) in list" :key="index"
                     :style="{backgroundImage: 'url(' + item.imagePath + ')' }" @click="handleClick(item.id, item.url)">
                </div>
        </div>
        <toast/>
    </div>
</template>

<script>
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import { getCryptoUserInfo } from '@/util/cryptoLocalStorage';

    export default {
        name: "QuestSlider",
        props: ['list'],
        components: {
            Swiper,
            SwiperSlide,
            Toast
        },
        data() {
            return {
                swiperOptions: {
                    loop: (this.list.length > 1),
                    autoplay: {
                        delay: 3000,
                    },
                }
            }
        },

        created() {

        },
        mounted() {

        },
        beforeDestroy() {

        },
        methods: {

            handleClick : function(id, url) {

                // //回傳 result，外部接收到 result事件後再做處理
                // this.$emit('onClickEvent', true, this.eventType);

                //確認是否爲問卷 url
                if (url !== undefined && url !== '' &&
                    (url.indexOf('survey') > -1)) {

                    let isLogin = this.$auth.isAdminLogin();
                    if (isLogin) {
                        // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                        const userData = getCryptoUserInfo();
                        let name = userData.name;
                        let tel = userData.phone;
                        let combo = name + ';' + tel + ';APP';
                        let crypto_ = this.$crypto.encryptText(combo);
                        let param = encodeURIComponent(crypto_);

                        this.callCheckQuestRecord(id, url)
                            .then( data => {
                                if (data) {
                                    //有填寫過
                                    this.$store.commit(mutationTypes.SHOW_TOAST, '已填寫過此問卷');
                                } else {
                                    //沒有填寫過
                                    let isCordova = !!window.cordova;
                                    if (isCordova) {
                                        //開啓頁面
                                        this.$public.openUrl(url + '/' + param);
                                    } else {
                                        window.open(url + '/' + param);
                                    }
                                }
                            })
                            .catch( error => {
                                this.$store.commit(mutationTypes.SHOW_TOAST, error);
                            });

                    } else {
                        //沒登入的話就導到登入
                        this.$router.push({name: 'Login'});
                    }
                }
            },

            /** 取得填過問卷的記錄 */
            callCheckQuestRecord: function (id, url) {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuth`CheckCanWrite${{
                        // id: id,
                        url: url,
                    }} ${ json => {
                        if (json !== undefined && json.status) {
                            if (json.data !== undefined && json.data !== null) {
                                //已經填寫過問卷: false，未填寫問卷: true
                                resolve(!json.data.canWrite);
                            } else {
                                //資料是空的
                                reject('沒有查到此問卷記錄');
                            }
                        } else {
                            reject('沒有查到此問卷記錄');
                        }
                    }}`;
                });
            },

        }

    }
</script>

<style scoped lang="less">
    .pic{
        width: 100%;
        height: 60vw;
        max-height: 612px;
        display: block;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }
</style>
